import { Link } from "react-router-dom";

const cols = [
  {
    title: "SOLUTIONS",
    links: [
      { to: "/ai-transformation", label: "AI Transformation" },
      { to: "/custom-software-development", label: "Custom Software" },
      { to: "/mobile-app-development", label: "Mobile App Development" },
      { to: "/saas-development", label: "SaaS Development" },
      { to: "/ai-automation", label: "AI Automation" },
      { to: "/services", label: "All Services →" },
    ],
  },
  {
    title: "EXPLORE",
    links: [
      { to: "/why", label: "Why AIROTECH" },
      { to: "/what-we-build", label: "What We Build" },
      { to: "/services", label: "Services & Add-ons" },
      { to: "/insights", label: "Insights & Guides" },
      { to: "/our-story", label: "Our Story" },
    ],
  },
  {
    title: "JOURNEY",
    links: [
      { to: "/how-it-works", label: "How It Works" },
      { to: "/build-levels", label: "Build Levels" },
      { to: "/start", label: "Start Your Journey" },
    ],
  },
];

export const Footer = () => {
  return (
    <footer className="border-t border-[#141414] bg-black">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid md:grid-cols-[1.4fr_1fr_1fr_1fr] gap-12">
          <div className="max-w-xs">
            <img src="/airotech-mark.png" alt="AIROTECH" className="h-10 w-auto mb-6" />
            <p className="text-sm text-zinc-500 leading-relaxed">
              Turning ideas into durable digital products — modern AI-assisted development, guided by real experience.
            </p>
          </div>

          {cols.map((c) => (
            <div key={c.title}>
              <div className="mono-label text-zinc-600 mb-5">{c.title}</div>
              <ul className="space-y-3.5 text-sm text-zinc-400">
                {c.links.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} className="hover:text-cyan-400 transition-colors duration-200">{l.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <div className="mono-label text-zinc-600 mb-5">CONTACT</div>
            <ul className="space-y-3.5 text-sm text-zinc-400">
              <li><a href="mailto:Hello@airotech-inc.com" className="hover:text-cyan-400 transition-colors duration-200">Hello@airotech-inc.com</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-[#141414] flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="mono-label text-zinc-700">© {new Date().getFullYear()} AIROTECH INC.</p>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 mono-label text-zinc-700">
            <Link to="/legal?doc=privacy_policy" data-testid="footer-privacy-link" className="hover:text-zinc-400 transition-colors duration-200">PRIVACY</Link>
            <Link to="/legal?doc=terms_of_service" data-testid="footer-terms-link" className="hover:text-zinc-400 transition-colors duration-200">TERMS</Link>
            <Link to="/legal?doc=cookie_notice" data-testid="footer-cookie-link" className="hover:text-zinc-400 transition-colors duration-200">COOKIE NOTICE</Link>
            <Link to="/legal?doc=subprocessor_disclosure" data-testid="footer-subprocessor-link" className="hover:text-zinc-400 transition-colors duration-200">SUBPROCESSORS</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
